import { ChangeDetectorRef, inject, signal } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { FuseConfigService } from "@fuse/services/config";
import { FuseConfirmationService } from "@fuse/services/confirmation";
import { FuseMediaWatcherService } from "@fuse/services/media-watcher";
import { ApiHttpService, ILayoutConfig, ItmToastrService, ItmUserService } from "@itm/services";
import { ItmNavigationService } from "@itm/services/itm-navigation.service";
import { GlobalStore } from "@itm/store/states/global.state";
import { Subject } from "rxjs";
import { now } from "moment-timezone";
import { BaseComponent } from "app/layout/common/base-component";

export abstract class ItmBaseComponent extends BaseComponent {

    protected readonly _http = inject(ApiHttpService);
    protected readonly _activatedRoute = inject(ActivatedRoute);
    protected readonly _fuseConfigService = inject(FuseConfigService);
    protected readonly _toastr = inject(ItmToastrService);
    protected readonly _itmUserService = inject(ItmUserService);
    protected readonly _router = inject(Router);
    protected readonly _changeDetectorRef = inject(ChangeDetectorRef);
    protected readonly _fuseMediaWatcherService = inject(FuseMediaWatcherService);
    protected readonly _fuseConfirmationService = inject(FuseConfirmationService);
    protected readonly _globalStore = inject(GlobalStore);
    protected readonly _itmNavigationService = inject(ItmNavigationService);
    protected _unsubscribeAll: Subject<any> = new Subject<any>();
    
    protected layoutConfigSig = signal<ILayoutConfig>(this._globalStore.LayoutConfig() ?? undefined);

    protected now: any = now();
    containerHeight: any = 0;
    gridHeight: any = 760;
    adjustForMobile: any = 182; //Height - Toolbar: 50; Menu/Footer: 68; Header: 64
    adjustForDesktop: any = 146;

    public getLoggedInUserEmail = signal<string>(this._itmUserService.getLoggedInUserEmail());

    constructor() {
        super();
        // console.log('ItmBaseComponent')
    }

    setGridWrapperHeight(){
        const parentDiv = document.getElementById('gridWrapper');
        if (parentDiv) {
            (parentDiv as HTMLElement).style.height = this.gridHeight + 'px';
        }
    }

    setInnerContainerHeight(){
        const parentDiv = document.getElementById('innerContainer');
        if (parentDiv) {
            (parentDiv as HTMLElement).style.height = this.containerHeight + 'px';
        }
    }
}
